#import "../fragments/lead-summary-fragment.graphql"

query GetLeadSummary($id: ID, $number: Int) {
    lead(id: $id, number: $number) {
        ...LeadSummaryFragment
    }
}
